import Api from '../../api/index';

const Company = {
	namespaced: true,
  state:{
    allCompanies: null,
    createCompanyWasGood: null,
    createCompanyMessage: null,

    indexCompanyWasGood: null,
    indexCompanyMessage: null,
  },
  mutations:{
    setAllCompanies(state, companies){
      state.allCompanies = companies //.data.map(o=>o.attributes)
    },
    pushNewCompany(state, company){
      state.allCompanies.push(company) //.data.attributes)
    },

    createResponse(state, {was_good, msg}){
      state.createCompanyWasGood = was_good
      state.createCompanyMessage = msg
      setTimeout(() => {
        state.createCompanyWasGood = null
      }, 100);
    },
    indexResponse(state, {was_good, msg}){
      state.indexCompanyWasGood = was_good
      state.indexCompanyMessage = msg
      setTimeout(() => {
        state.indexCompanyWasGood = null
      }, 100);
    },
  },
  actions: {
    index(context){
      Api.Company.index()
      .then(response => response.data)
      .then(Companies => {
        context.commit('setAllCompanies', Companies);
        context.commit('indexResponse', {msg: '', was_good: true});
      }).catch(function(error) {
        context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
           // auto-comment// console.log(error);
      });
    },

    create(context, company){
      Api.Company.create(company)
      .then(response => response.data)
      .then(Company => {
        context.commit('pushNewCompany', Company);
        context.commit('createResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
             // auto-comment// console.log(error);
        });
    }
  }
}

export default Company